import { Types } from './types'

const initialState = {
    dataAgency: {
        paging: {},
        rows: [],
    },
    dataAgencyReview: {
        paging: {},
        rows: [],
    },
    dataConfigAgency: {
        paging: {},
        rows: [],
    },
    dataRequestAgency: {
        paging: {},
        rows: [],
    },
    dataAllConfigAgency: [],
}
const agencyReducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_CONFIG_AGENCY:
            return {
                ...newState,
                dataConfigAgency: action.payload
            }
        case Types.SAVE_LIST_AGENCY:
            return {
                ...newState,
                dataAgency: action.payload
            }
        case Types.SAVE_LIST_REQUEST_AGENCY:
            return {
                ...newState,
                dataRequestAgency: action.payload
            }
        case Types.SAVE_LIST_ALL_CONFIG_AGENCY:
            return {
                ...newState,
                dataAllConfigAgency: action.payload
            }
        case Types.SAVE_LIST_AGENCY_REVIEW:
            return {
                ...newState,
                dataAgencyReview: action.payload
            }
        default:
            return { ...newState }
    }
}
export default agencyReducer
